import { render } from "./ServicoList.vue?vue&type=template&id=2512f5ba&ts=true"
import script from "./ServicoList.vue?vue&type=script&lang=ts"
export * from "./ServicoList.vue?vue&type=script&lang=ts"

import "./ServicoList.vue?vue&type=style&index=0&id=2512f5ba&lang=css"

import exportComponent from "/Users/camp/Desktop/code-time/acampa-gestao-pra/vuecode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__